import React from "react";
import "./PrimaryButton.scss";

interface PrimaryButtonProps {
  text: string;
  onClick: () => void;
  className?: string;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({ 
  text, 
  onClick, 
  className = "" 
}) => {
  return (
    <button
      className={`cc-primary-button ${className}`}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default PrimaryButton;

